<template>
    <div>
        <div>
            <div class="wrap">
                <div class="main-wrap">
                    <div class="main-wrap__grid">
                        <div class="nav-tree">
                            <el-select v-model="rowDataId" placeholder="Select User Type" size="mini">
                                <el-option
                                        v-for="item in rowData"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        @click.native="onSelectionChanged(item)">
                                    <!--@click.native="setValueStages(item.id)"-->
                                </el-option>
                            </el-select>
                            <el-button class="nav-tree__item" size="mini" type="primary" @click="groupOpenModal('add')" plain icon="el-icon-plus">Add User Type</el-button>
                            <el-button :disabled="selectedRow.serviceIndex !== 0" class="nav-tree__item" @click="groupOpenModal('edit')" size="mini" type="primary" plain icon="el-icon-edit">Edit User Type</el-button>
                            <el-button :disabled="selectedRow.serviceIndex !== 0" class="nav-tree__item" @click="deleteGroupOpenModal" size="mini" type="primary" plain icon="el-icon-delete">Delete User Type</el-button>
                        </div>
                    </div>
                    <div class="main-wrap__table">
                        <transition name="fade">
                            <div v-if="show">
                                <el-table :data="myTableData" border fit
                                          style="width: 100%">
                                    <el-table-column width="300px" min-width="150px" label="Item" class-name="first-column">
                                        <template slot-scope="scope">
                                            <span>{{scope.row.group}}</span>
                                            <el-checkbox v-model="scope.row.checkAll"
                                                         label="Check All"
                                                         :disabled="disabledBtn"
                                                         :indeterminate="scope.row.isIndeterminate"
                                                         border
                                                         size="mini"
                                                         @change="test(scope.row.checkAll, scope.row, scope)"></el-checkbox>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="150px"  label="Permissions (Check box to allow item permission)">
                                        <template slot-scope="scope">
                                            <el-checkbox-group v-model="scope.row.checkedArr">
                                                <el-checkbox v-for="item in scope.row.permissions"
                                                             :key="item.name"
                                                             :disabled="disabledBtn"
                                                             :label="item.name"
                                                             @change="handleCheckedCitiesChange(item.name, scope)"
                                                ></el-checkbox>
                                            </el-checkbox-group>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div class="update-btn">
                                    <el-button type="primary" @click="update">Update</el-button>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal blocking :title="groupToggle ? 'Add User Type' : 'Edit User Type'" ref="group" class="modal" v-on:close="closeGroupModal">
            <el-form :model="formGroup" status-icon ref="form" label-width="0" class="demo-ruleForm">
                <el-form-item>
                    <el-input v-if="groupToggle" label="Name" v-model="formGroup.name"></el-input>
                    <el-input v-else label="Name" v-model="formGroup.name"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                    <el-button @click="modalCancel('group')">Cancel</el-button>
                    <el-button v-if="groupToggle" @click="addGroupSubmit(formGroup)" type="primary">Submit</el-button>
                    <el-button v-else @click="editGroupSubmit(formGroup)" type="primary">Submit</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
        <sweet-modal blocking ref="confirmation" title="Delete User Type">
            Are you sure you want to delete this User Type?
            <template slot="box-action">
                <el-button class="button" @click="deleteConfirm">Ok</el-button> &nbsp;
            </template>
        </sweet-modal>
    </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  export default {
    name: 'MyPermissions',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

    },
    beforeCreate() {

    },
    beforeMount() {

    },
    mounted(){
      this.getGroups(this.$route.query.companyId);
      this.GetRoles();
    },
    data() {
      return {
        isIndeterminate:true,
        show: true,
        myList:[],
        myRow:{
          group: '',
          permissions:[]
        },
        selectedRow:{},
        groupToggle: true,
        formGroup: {
          name: '',
          access: ' '
        },
        checked:null,
        tableData2:[],

        rowDataId: '',
        rowData: null,
        companyId: '',
        disabledBtn: true,
        myTableData:[],
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      test(index, row, scope){
        let fullArr = [];
        for(let i = 0; i < row.permissions.length; i++){
          fullArr.push(row.permissions[i].name)
          let ifFind = this.find2(this.selectedRow.access.split(','), row.permissions[i].name)
          if(index && !ifFind || !index && ifFind){
            this.handleCheckedCitiesChange(row.permissions[i].name)
          }
        }
        row.checkedArr = index ? fullArr : [];
        row.isIndeterminate = false;
      },
      checkBox(item){
      },
      setGroups(){
        this.disabledBtn = true
        this.getGroups(this.$route.query.companyId)
        this.GetRoles()
      },
      getGroups(id){
        return new Promise ((resolve,reject) =>{
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUserGroup/list?companyId=${id} `)
            .then(response => {
              console.log('ROWDATA', response.data);
              this.rowData = response.data.list
              resolve(this.rowData)
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject('err')
              loader.hide()
            });
        })
      },
      //TODO
      allCheckByOne(item, row){
        let checkedCount = row.row.checkedArr.length
        let fullArrayPermissions = row.row.permissions.length
        // console.log('checkedCount', checkedCount, 'fullArrayPermissions', fullArrayPermissions)
        row.row.checkAll = checkedCount === fullArrayPermissions
        row.row.isIndeterminate = checkedCount > 0 && checkedCount < fullArrayPermissions
      },
      handleChecedArray(value){
        console.log('VALUE', value)
      },
      handleCheckedCitiesChange(item, row){
        // console.log('item', item)
        if(row){
          this.allCheckByOne(item, row)
        }

        if(this.selectedRow.access === " "){
          this.selectedRow.access = []
        }

        if(typeof this.selectedRow.access === 'string' ){
          this.selectedRow.access = this.selectedRow.access.split(',')
        }

        for (let i = 0; i < this.selectedRow.access.length; i++) {
          if (this.selectedRow.access[i] === item) {
            this.selectedRow.access.splice(i, 1)
            this.selectedRow.access = this.selectedRow.access.join()
            if (this.selectedRow.access.length == 0){
              this.selectedRow.access = ' '
            }
            console.log('this.selectedRow.access DELETED', this.selectedRow.access)
            return
          }
        }

        this.selectedRow.access.indexOf(item) === -1 ? this.selectedRow.access.push(item) : console.log("This item already exists")

        this.selectedRow.access = this.selectedRow.access.join()

        // console.log('this.selectedRow.access', this.selectedRow.access)
        // if (this.selectedRow.access.length == 0){
        //   alert('hello')
        //   this.selectedRow.access = ' '
        // }

        // TODO 1 вариант
        // if (~this.selectedRow.access.indexOf(item)) {
        //   // alert( 'совпадение есть!' );
        //   this.selectedRow.access = this.selectedRow.access.replace(`${item},`, '')
        // }else{
        //   this.selectedRow.access += item + ','
        // }
        console.log('this.selectedRow.access ADDED', this.selectedRow.access)
        // console.log('selectedRow', this.selectedRow)
      },
      groupOpenModal(state){
        if(state === 'add'){
          this.groupToggle = true
        }else if(state === 'edit'){
          this.formGroup.name = this.selectedRow.name
          this.formGroup.access = this.selectedRow.access
          this.groupToggle = false
        }
        this.$refs.group.open();
      },
      deleteGroupOpenModal(){
        // this.$refs.confirmation.open();

        this.$confirm('This will permanently delete the vendor. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companyUserGroup/delete?companyId=${this.$route.query.companyId}&companyUserGroupId=${this.selectedRow.id}`)
            .then(response => {
              console.log('---', response.data);
              this.getGroups(this.$route.query.companyId).then(rowData => {
                console.log('new data', rowData)
                this.selectedRow = this.selectCreatedTask(rowData, rowData[0].id)
                console.log('selectedRow', this.selectedRow)
                this.rowDataId = rowData[0].id
                this.getGroupItem(rowData[0].id)
              }).catch(err => console.log(err))
              this.notification("Success", "Group deleted", "success");
              this.$refs.confirmation.close();
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      addGroupSubmit(form){
        form.access = ' '
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserGroup/create?companyId=${this.$route.query.companyId}`, form)
          .then(response => {
            this.getGroups(this.$route.query.companyId).then(rowData => {
              console.log('new data', rowData)
              this.selectedRow = this.selectCreatedTask(rowData, response.data.companyUserGroupId)
              console.log('selectedRow', this.selectedRow)
              this.rowDataId = response.data.companyUserGroupId
              this.disabledBtn = false;
              this.getGroupItem(response.data.companyUserGroupId)
            }).catch(err => console.log(err))
            // setTimeout(() => {
            //   this.selectCreatedTask(response.data.companyUserGroupId)
            // }, 1000)
            console.log('---', response.data);
            loader.hide()
            this.$refs.group.close();
            this.notification("Success", "User Type added", "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      editGroupSubmit(form){
        // form.access = ' '
        if(form.access[0] === ' '&& form.access.length > 1 ){
          form.access = form.access.substr(1)
        }else if(!form.access){
          form.access = ' '
        }
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserGroup/update?companyId=${this.$route.query.companyId}&companyUserGroupId=${this.selectedRow.id}`, form)
          .then(response => {
            this.$store.dispatch('getCompanyLayout')
            this.getGroups(this.$route.query.companyId).then(rowData => {
              console.log('new data', rowData)
              this.selectedRow = this.selectCreatedTask(rowData, this.selectedRow.id)
              this.getGroupItem(this.selectedRow.id)
            }).catch(err => console.log(err))
            console.log('---', response.data);
            // this.getGroups(this.$route.query.companyId)
            // this.getGroupItem(this.selectedRow.id)
            loader.hide()
            this.$refs.group.close();
            this.notification("Success", "User Updated", "success");
            // setTimeout(() => {
            //   this.selectCreatedTask(this.selectedRow.id)
            // }, 1500)
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      deleteConfirm(){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserGroup/delete?companyId=${this.$route.query.companyId}&companyUserGroupId=${this.selectedRow.id}`)
          .then(response => {
            console.log('---', response.data);
            this.getGroups(this.$route.query.companyId)
            this.$refs.confirmation.close();
            this.notification("Success", "Group deleted", "success");
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      GetRoles(){
        this.show = false
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserAccess/list?companyId=${this.$route.query.companyId} `)
          .then(response => {
            console.log('---', response.data);
            this.tableData2 = response.data.list
            this.createMytable(response.data.list)
            this.show = true
          })
          .catch(error => {
            this.show = true
            console.log('An error occurred:', error);
          });
      },
      onSelectionChanged(item) {
        console.log('this.myTableData1', this.myTableData)

        // var selectedRows = this.gridApi.getSelectedRows();
        this.selectedRow = item
        this.disabledBtn = false;
        this.getGroupItem(this.selectedRow.id)
      },
      getGroupItem(id){
        this.show = false
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/companyUserGroup/item?companyId=${this.$route.query.companyId}&companyUserGroupId=${id}`)
          .then(response => {
            if(response.data.success){
              if(response.data.item.access === ' '){
                response.data.item.access = ''
              }
              console.log('---', response.data);
              for (let i = 0; i < this.myTableData.length; i++){
                this.myTableData[i].checkedArr = []
                // console.log(response.data.item.access)
                // console.log('this.myTableData[i].permissions.name', this.myTableData[i].permissions)
                let isTrue = 0
                for (let b = 0; b < this.myTableData[i].permissions.length; b++){
                  this.myTableData[i].permissions[b].state = false
                  let ifFind = this.find2(response.data.item.access.split(','), this.myTableData[i].permissions[b].name)
                  // console.log('split', ifFind)
                  if(ifFind){
                    // if(~response.data.item.access.indexOf(this.myTableData[i].permissions[b].name) ){
                    //   alert(this.myTableData[i].permissions[b].name)
                    // console.log('this.myTableData[i].permissions[b].name', this.myTableData[i].permissions[b].name)
                    this.myTableData[i].permissions[b].state = true
                    this.myTableData[i].checkedArr.push(this.myTableData[i].permissions[b].name)
                    // console.log('this.myTableData[i].checkedArr.push(this.myTableData[i].permissions[b].name)', this.myTableData[i].permissions[b].name)
                    isTrue++
                  }
                }
                if(this.myTableData[i].permissions.length === isTrue && this.myTableData[i].permissions.length !== 0){
                  this.myTableData[i].checkAll = true
                  this.myTableData[i].isIndeterminate = false
                }else{
                  this.myTableData[i].checkAll = false
                  this.myTableData[i].isIndeterminate = true
                }
                if(!this.myTableData[i].checkedArr.length){
                  this.myTableData[i].isIndeterminate = false
                }
              }
              this.show = true
            }
            console.log('this.myTableData',this.myTableData)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      update(){
        if (this.selectedRow.access.length == 0){
          this.selectedRow.access = ' '
        }
        this.formGroup.access = this.selectedRow.access
        this.formGroup.name = this.selectedRow.name
        // if(this.formGroup.access.slice(-1) === ','){
        //   // alert('hello')
        //   this.formGroup.access = this.formGroup.access.substring(0, this.formGroup.access.length - 1)
        // }
        this.editGroupSubmit(this.formGroup)
      },
      selectCreatedTask(rowData, id){
        for (let i = 0; i < rowData.length; i++){
          if(rowData[i].id === id) return rowData[i]
        }
      },
      // test(rowIndex){
      //   console.log(rowIndex)
      // },
      arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 10 || rowIndex === 11) {
          if (columnIndex === 1) {
            return [1, 5];
          } else if (columnIndex === 1) {
            return [0, 0];
          }
        }
      },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      onGridReady(params) {},
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      createMytable(data){
        this.myTableData = []

        let group = ''
        for (let i = 0; i < data.length; i++){
          let row = {
            group: '',
            isIndeterminate: true,
            checkAll:false,
            checkedArr: [],
            permissions:[]
          }
          // console.log('group!!!', group, 'data[i].group!!!', data[i].group)
          if(group !== data[i].group){
            // console.log('group', group, 'data[i].group', data[i].group)
            row.group = data[i].group
            for (let b = 0; b < data.length; b++){
              let t = {
                name: '',
                state: false
              }
              if(row.group === data[b].group){
                t.name = data[b].name
                row.permissions.push(t)
              }
            }
            let ifFind = this.find(this.myTableData, row.group)

            if (!ifFind){
              this.myTableData.push(row)
            }

            // this.myTableData.push(row)
            group = data[i].group
            // row = {
            //   group: '',
            //     isIndeterminate: true,
            //     checkAll:false,
            //     checkedArr: [],
            //     permissions:[]
            // }
          }
          console.log('sameGroup1', this.myTableData)
        }
        console.log('MY TABLE DATA FINAL', this.myTableData)
      },
      find(array, val) {
        for (var m = 0; m < array.length; m++) {
          if (array[m].group == val) return true;
        }
        return false
      },
      find2(array, val) {
        for (var b = 0; b < array.length; b++) {
          if (array[b] == val) return true;
        }
        return false
      },
      closeGroupModal(){
        this.formGroup.name = ''
      },
      // openDialog(){
      //   this.$emit('openChat2')
      // }
      async loadProjectPermissionsList(){
        try {
          const permissionRules = await this.getPermissionsRulesList();

          const permissionPressets = await this.getPermisssionsPressetsList()
        } catch (err) {
          console.log(err)
        }
      },
      getPermissionsRulesList(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionRules/list`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        })
      },
      getPermisssionsPressetsList(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionPressets/list`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.list)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
    .flex{
        /*display:flex;*/
    }
    .content {
        /*display: flex;*/
    }
    .wrap {
        width: 100%;
        padding: 0 10px 10px 10px;
    }
    .main-wrap{
        height:95%;
    }
    .main-wrap__table{
        width:100%;
        padding: 10px;
        h3{
            margin-top: 0;
            margin-bottom: 35px;
        }
    }
    .main-wrap__grid{
        width:600px;
        padding: 10px;
    }
    .nav-tree{
        display:flex;
        justify-content: space-between;
    }
    .group-name{
        margin-left:10px;
    }
    .update-btn{
        margin-top:20px;
    }
    /deep/.first-column{
        .cell{
            display:flex;
            justify-content:space-between;
        }
    }
</style>
